module.exports = __webpack_public_path__ + "img/brightpoint_3.60c3ebd2.png";